export default __webpack_public_path__ + "static/media/multi.84e2ead7.png";